module.exports = __webpack_public_path__ + "img/svea_christiansen_7.18ba31ac.jpg";